/**
 * API service for the Flow Planning Dashboard
 */
import {
    GetFlowMonitoringDataInput,
    GetFlowMonitoringDataOutput,
    CompareFlowMonitoringDataInput,
    CompareFlowMonitoringDataOutput,
} from './model';
import { API_GATEWAY_PROCESS_NAME } from '../../../utils/constants';
import { apiRequest } from '../../../services/apiMiddleware';
import { store } from '../../../store';
import { selectStationCode } from '../../../store/slices/shiftPlanSlice';
import {
    logOperationalMetric,
    MetricType,
    RCC_SHIFT_PLAN_FLOW_PLANNING_DASHBOARD_TAB,
    GET_FLOW_MONITORING_DATA_API,
    COMPARE_FLOW_MONITORING_DATA_API,
} from '../../../utils/metric-utils';

/**
 * Fetch FCLM target data for the given warehouse and time window
 */
export const getFlowMonitoringData = async (
    request: GetFlowMonitoringDataInput
): Promise<GetFlowMonitoringDataOutput> => {
    const startTime = Date.now();
    const stationCode = selectStationCode(store.getState()) || '';
    const requestPayload = {
        resourcePath: '/getFlowMonitoringData',
        httpMethod: 'post',
        processName: API_GATEWAY_PROCESS_NAME,
        requestBody: request,
    };
    try {
        const response = await apiRequest(requestPayload);
        logOperationalMetric(startTime, stationCode, RCC_SHIFT_PLAN_FLOW_PLANNING_DASHBOARD_TAB, GET_FLOW_MONITORING_DATA_API, MetricType.SUCCESS);
        return response.data;
    } catch (error: any) {
        logOperationalMetric(startTime, stationCode, RCC_SHIFT_PLAN_FLOW_PLANNING_DASHBOARD_TAB, GET_FLOW_MONITORING_DATA_API, MetricType.FAILED, error);
        throw error;
    }
};

/**
 * Compare actual flow monitoring data against a baseline (e.g. latest shift plan)
 */
export const compareFlowMonitoringData = async (
    request: CompareFlowMonitoringDataInput
): Promise<CompareFlowMonitoringDataOutput> => {
    const startTime = Date.now();
    const stationCode = selectStationCode(store.getState()) || '';
    const requestPayload = {
        resourcePath: '/compareFlowMonitoringData',
        httpMethod: 'post',
        processName: API_GATEWAY_PROCESS_NAME,
        requestBody: request,
    };
    try {
        const response = await apiRequest(requestPayload);
        logOperationalMetric(startTime, stationCode, RCC_SHIFT_PLAN_FLOW_PLANNING_DASHBOARD_TAB, COMPARE_FLOW_MONITORING_DATA_API, MetricType.SUCCESS);
        return response.data;
    } catch (error: any) {
        logOperationalMetric(startTime, stationCode, RCC_SHIFT_PLAN_FLOW_PLANNING_DASHBOARD_TAB, COMPARE_FLOW_MONITORING_DATA_API, MetricType.FAILED, error);
        throw error;
    }
};
